<div
  class="controlsGroupWrapper"
>
  <div
    class="radioButtonsSection"
  >
    <div>
      Выберите тип турнира:
    </div>
    <div
      class="radioButtonsGroup"
    >
      <div
        class="radioButtonSection"
        *ngFor="let key of getObjectKeys(getTournamentCheckBoxLabels())"
      >
        <input
          id="{{key}}"
          type="radio"
          (click)="setChosenTournamentType($event)"
          [checked]="getChosenTournamentType() === key"
        >
        <div
          class="radioButtonLabel"
        >
          {{getTournamentCheckBoxLabels()[key]}}
        </div>
      </div>
    </div>
  </div>
  <div
    class='thirdPlaceTournamentCheckBoxSection'
    *ngIf="isConventional()"
  >
    <input
      id="thirdPlaceTournamentCheckBox"
      type="checkbox"
      [checked]="getThirdPlaceTournamentAvailable()"
      (click)="setThirdPlaceTournamentAvailable()"
    >
    <div
      class="thirdPlaceTournamentCheckBoxLabel"
    >
      Нужен матч за третье место
    </div>
  </div>
</div>
